import { render } from "./dialog_scrollbar.vue?vue&type=template&id=5b108173&scoped=true"
import script from "./dialog_scrollbar.vue?vue&type=script&lang=js"
export * from "./dialog_scrollbar.vue?vue&type=script&lang=js"

import "./dialog_scrollbar.vue?vue&type=style&index=0&id=5b108173&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b108173"]])

export default __exports__